import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MOCK_FR_CONTENT_TYPE;

import { MockFrContentTypeName } from "./ContentTypeName";
import { fieldTypes } from "./FieldTypes";
import { slideshow } from "./Slideshow";
var MOCK_FR_CONTENT_TYPES = (_MOCK_FR_CONTENT_TYPE = {}, _defineProperty(_MOCK_FR_CONTENT_TYPE, MockFrContentTypeName.Slideshow, slideshow), _defineProperty(_MOCK_FR_CONTENT_TYPE, MockFrContentTypeName.FieldTypes, fieldTypes), _MOCK_FR_CONTENT_TYPE);
export default MOCK_FR_CONTENT_TYPES;
export * from "./ContentTypeName";